import { render, staticRenderFns } from "./shippingOperationForm.vue?vue&type=template&id=08bfd820"
import script from "./shippingOperationForm.vue?vue&type=script&lang=js"
export * from "./shippingOperationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports